@if (label && floatingLabel) {
    <cb-display-value-new label="{{ label }}">
        <span class="flex" [ngClass]="textClass"
            >{{ userFullNameDiplay.value }} {{ formattedDate.value }}</span
        >
    </cb-display-value-new>
}
@if (label && !floatingLabel) {
    <span class="flex" [ngClass]="textClass">
        {{ label }} {{ userFullNameDiplay.value }}
        {{ formattedDate.value }}
    </span>
}
@if (!label) {
    <span class="flex"> {{ userFullNameDiplay.value }} {{ formattedDate.value }} </span>
}
